module.exports = __webpack_public_path__ + "img/farming-by-numbers--eggs.555567f9.png";